import { createRoute } from './createRoute';

const home = createRoute('');
const subscribers = home;
const subscribersSearch = createRoute('', { search: ['q'] });
const serviceLevels = createRoute('service-levels');
const serviceLevelsCreate = createRoute(`${serviceLevels.path}/create`);
const serviceLevelsDetails = createRoute(`${serviceLevels.path}/:serviceLevelId`);
const configuration = createRoute('configuration');
const subscriptionLinesDetails = createRoute('subscriptions/:subscriptionId');
const subscriptionLines = createRoute(`${subscriptionLinesDetails.path}/*`);

export const routes = {
  home,
  subscribers,
  subscribersSearch,
  serviceLevels,
  serviceLevelsCreate,
  serviceLevelsDetails,
  configuration,
  subscriptionLines,
  subscriptionLinesDetails,
} as const;
